var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2027_13444)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.1692 3H19.54L27.4699 11.2774V27.3518C27.4699 29.365 25.8451 31 23.832 31H10.1692C8.16628 31 6.53125 29.365 6.53125 27.3518V6.63795C6.53121 4.63503 8.16628 3 10.1692 3Z",
    fill: "#092F41"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.302,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.5293 3V11.2058H27.4694L19.5293 3Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6231 22.6L13.3165 21.7007H11.753L11.4464 22.6H10.1895L11.9573 17.8584H13.1018L14.8697 22.6H13.6231ZM12.1004 20.6993H12.969L12.5296 19.4423L12.1004 20.6993ZM15.2479 22.6V17.8584H17.2712C17.7617 17.8584 18.1603 18.0015 18.4566 18.2774C18.7632 18.5533 18.9063 18.9212 18.9063 19.381C18.9063 19.8409 18.7632 20.2088 18.4566 20.4847C18.1603 20.7606 17.7617 20.8934 17.2712 20.8934H16.4639V22.6H15.2479ZM16.4639 19.8613H17.1384C17.3121 19.8613 17.4551 19.8205 17.5573 19.7387C17.6493 19.6467 17.7004 19.5343 17.7004 19.381C17.7004 19.2277 17.6493 19.1051 17.5573 19.0234C17.4551 18.9314 17.3121 18.8905 17.1384 18.8905H16.4639V19.8613ZM22.2887 22.6L21.0216 20.6482L20.623 21.0774V22.6H19.407V17.8584H20.623V19.4628L22.0946 17.8584H23.6683L21.8698 19.7693L23.8114 22.6H22.2887Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2027_13444"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white",
    transform: "translate(3 3)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileIcon2);
export default __webpack_public_path__ + "static/media/file_icon2.20cc6a20eee9bc540408c954d1520d47.svg";
export { ForwardRef as ReactComponent };